/**
 * JoMoNn Scroll Animation Engine
 * IntersectionObserver-based reveal, parallax, and scale effects.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.jm-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  // Reveal animations via IntersectionObserver
  var revealObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  document.querySelectorAll('.jm-reveal').forEach(function (el) {
    revealObserver.observe(el);
  });

  // Parallax + Scale via scroll position (rAF throttled)
  var parallaxEls = document.querySelectorAll('.jm-parallax');
  var scaleEls = document.querySelectorAll('.jm-scale');
  var ticking = false;

  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(updateEffects);
      ticking = true;
    }
  }

  function updateEffects() {
    var scrollY = window.pageYOffset;
    var viewH = window.innerHeight;

    parallaxEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var speed = parseFloat(el.dataset.speed || '0.3');
      if (rect.bottom > 0 && rect.top < viewH) {
        var offset = (rect.top - viewH / 2) * speed;
        el.style.transform = 'translateY(' + offset + 'px)';
      }
    });

    scaleEls.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.bottom > 0 && rect.top < viewH) {
        var progress = 1 - rect.top / viewH;
        var scaleMin = parseFloat(el.dataset.scaleMin || '0.85');
        var scaleMax = parseFloat(el.dataset.scaleMax || '1');
        var scale = scaleMin + (scaleMax - scaleMin) * Math.min(Math.max(progress, 0), 1);
        el.style.transform = 'scale(' + scale.toFixed(4) + ')';
      }
    });

    ticking = false;
  }

  if (parallaxEls.length > 0 || scaleEls.length > 0) {
    window.addEventListener('scroll', onScroll, { passive: true });
    updateEffects();
  }

  // Add smooth scroll class to html
  document.documentElement.classList.add('jm-smooth');
})();
